import Page from '../page';
import FormValidator from '../../helpers/form-validator';
import EventEmitter from 'eventemitter3';
import Request from "../../lib/ajax/request";

export default class MyaccountIndex extends Page {

	constructor(...args) {
		super(...args);

		this._action = "candiapro_user_update_informations";
		this._is_process = false;

		this._retrieveDOM();
		this._initTls();

		this.FormValidator = new FormValidator({
			inputs: this.dom.formInput
		});

		this._ManageFavoriteRecipes = new ManageFavoriteRecipes({
           'container': this.dom.views.containerFavoriteRecipes
        });
	}

	_retrieveDOM() {
		super._retrieveDOM();

        this.dom.views = {};

		// Inputs
		this.dom.formInput = this.dom.page.querySelectorAll('.js-form-input');
		this.dom.formSelect = this.dom.page.querySelectorAll('.js-form-select');
        this.dom.optNewsletter = this.dom.page.querySelector( '.js-form-opt-newsletter' );

		// Process
		this.dom.message = this.dom.page.querySelector('.js-response-update');
		this.dom.send = this.dom.page.querySelector('.js-btn-changes');

		this.dom.views.containerFavoriteRecipes = this.dom.page.querySelector( '.js-favorite-recipes-container' );
	}

	bind() {
		super.bind();

		this.dom.send.addEventListener('click', this._process.bind(this));

		for (let i = 0; i < this.dom.formSelect.length; i++) {
			const el = this.dom.formSelect[i];
			el.addEventListener('change', this._checkSelect.bind(this, el));
			el.addEventListener('change', this._showSend.bind(this));
		}
		for (let i = 0; i < this.dom.formInput.length; i++) {
			const el = this.dom.formInput[i];
			el.addEventListener('change', this._showSend.bind(this));
		}

        this.dom.optNewsletter.addEventListener('change', this._showSend.bind(this));

    }

	// PROCESS
	_process() {

		if( this._is_process == false ) {
			this._is_process = true;
			let vForm = this.FormValidator.isValid();
			let vSelects = this._checkSelects();
			let objectValues = {};

			if (vForm && vSelects) {
				objectValues = this.FormValidator.getData();

				for (let i = 0; i < this.dom.formSelect.length; i++) {
					let el = this.dom.formSelect[i];
					let cat = el.getAttribute('data-cat');
					objectValues[cat] = el.value;
				}

                // Get Option Newsletter
                objectValues[ 'opt_newsletter' ] = ( this.dom.optNewsletter.checked ) ? true : false;

				// FINAL OBJECT
				this._send(objectValues);
			} else {
				this._is_process = false;
			}
		}
	}

    _send(obj) {

        // Format data
        var data = new FormData();
        data.append( 'target_id', this.dom.page.getAttribute('target-id') );
        data.append( 'data', JSON.stringify( obj ) );

        document.body.classList.add('loading');
        this.dom.send.classList.add('loading');
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/ajax.php?action=' + this._action, true);
        xhr.onreadystatechange = function () {
            console.log(xhr);
            if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                this._response( JSON.parse(xhr.response) );
            }
        }.bind(this);
        xhr.send( data );

        // this.dom.responseError.innerHTML = xhr.error.msg;
    }


    _response( response ) {

        this._is_process = false;

        if( response.success == true ) {

            this.dom.message.innerHTML = response.data.message;
            this.dom.send.classList.remove('show');
            this.dom.message.classList.add('show');

        } else {
            document.body.classList.remove('loading');
            this.dom.send.classList.remove('loading');

            /** Bad email **/
            if( response.data.error == 'invalid_email' )
            {
                // this.dom.responseError.innerHTML = response.data.error_message;
            }
        }

    }

	// HELPERS & CHECKS

	_showSend() {
        this.dom.message.classList.remove('show');
        this.dom.message.innerHTML = '';
		this.dom.send.classList.add('show');
	}
	
	_getValues() {
		let objectPreviousValues = {};
		objectPreviousValues = this.FormValidator.getData();
	}


	_checkSelect(el) {
		if (el.value == '') {
			el.classList.add('error');
			el.classList.remove('success');
			return false;
		} else {
			el.classList.remove('error');
			el.classList.add('success');
			return true;
		}
	}

	_checkSelects() {
		let valid = true;
		for (let i = 0; i < this.dom.formSelect.length; i++) {
			const el = this.dom.formSelect[i];
			if (this._checkSelect(el) == false)
				valid = false;
		}

		return valid;
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}

/**
 Class ManageFavoriteRecipes
 Manage the favorite recipes of the connected user
 Params : {
        container: the global container of favorite recipes
    }
 **/
export class ManageFavoriteRecipes extends EventEmitter {

    constructor( opts ) {
        super();

        this._container = opts.container || false;

        this._retrieveDOM();
        this._init();
        this._bind();
    }

    _retrieveDOM() {
        this.views = {};

        this.views.page = document.body.querySelector('div[data-page][data-entity]');
        this.views.btnRemoveRecipes = [].slice.call( this._container.querySelectorAll( '.js-remove-item' ) );
    }

    _init() {

        this._is_process = false;
        this._indexToRemove = null;
        this._recipe_id = null;

        this._action = 'candiapro_bookmark';
        this._user_id = this.views.page.getAttribute( 'target-id' );

        this._data = new FormData();
        this._data.append( 'sub_action', 'remove' );
        this._data.append( 'user_id', this._user_id );
    }

    _bind() {

        for( let i = 0, j = this.views.btnRemoveRecipes.length; i < j; i++ ) {
            this.views.btnRemoveRecipes[ i ].addEventListener( 'click', this._clickBtnRemoveRecipe.bind(this) );
        }
    }

    /**
     Function "_clickBtnRemoveRecipe"
     Called when the user clicks on the closing cross of a recipe : retrieving the id of the recipe to delete
     **/
    _clickBtnRemoveRecipe( event ) {

        if( this._is_process == false ) {
            this._is_process = true;

            let target = event.currentTarget;
            this._indexToRemove = this.views.btnRemoveRecipes.indexOf( target );
            this._recipe_id = target.getAttribute( 'data-recipe-id' );

            if( this._recipe_id ) {
                this._data.append( 'recipe_id', this._recipe_id );
                this._requestToRemoveRecipe();
            }
        }
    }

    /*
       Function "_requestToRemoveRecipe"
       Request AJAX to delete a favorite recipe from the logged in user
   */
    _requestToRemoveRecipe() {
        const xhr = new XMLHttpRequest();

        xhr.open( 'POST', '/ajax.php?action=' + this._action, true );

        xhr.onreadystatechange = function () {

            if( xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200 ) {
                this._response( JSON.parse( xhr.response ) );
            }
            this._is_process = false;

        }.bind( this );

        xhr.send( this._data );
    }

    /*
        Function "_response"
        Called when request is over : if the request went well, we delete the recipe from the view
        @Params :
            xhr: object => the element returned by the request AJAX
    */
    _response( response, callback = () => {}) {
        if( response.success == true ) {

            // Remove recipe from DOM
            if( this.views.btnRemoveRecipes.length > 0 ) {

                // Get parent
                let parent = closest(  this.views.btnRemoveRecipes[ this._indexToRemove ] ,'.ct.ct--recipe-item' );
                if (typeof parent.remove === 'function') {
                    parent.remove();
                } else {
                    parent.parentNode.removeChild(parent);
                }

                // Update buttons array
                if (typeof this.views.btnRemoveRecipes[ this._indexToRemove ].remove === 'function') {
                    this.views.btnRemoveRecipes[ this._indexToRemove ].remove();
                } else {
                    this.views.btnRemoveRecipes[ this._indexToRemove ].parentNode.removeChild(this.views.btnRemoveRecipes[ this._indexToRemove ]);
                }
                this.views.btnRemoveRecipes.splice( this._indexToRemove, 1 );

                this.emit('recipes:remove', parent);

            }

            // Show no-results text
            if( this.views.btnRemoveRecipes.length == 0 ) {
                this._container.classList.add('empty');
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/my-account/my-account-index.js